import { Link } from 'react-router-dom';
import { LEGAL_ENTITY, PRODUCT_NAME, EFFECTIVE_DATE } from '../../../shared/legal/constants';
import LandingLegalFooter from './LandingLegalFooter';

/**
 * Shared layout for public legal pages linked from the landing site.
 */
export default function LandingPolicyShell({ title, children }) {
    return (
        <main className="bg-[#0D0221] text-gray-200 min-h-screen px-6 py-16">
            <div className="max-w-4xl mx-auto">
                <Link
                    to="/"
                    className="inline-flex items-center text-sm text-gray-400 hover:text-[#00FFD0] mb-8 transition"
                >
                    ← Back to {PRODUCT_NAME}
                </Link>

                <header className="mb-10">
                    <h1 className="text-3xl md:text-4xl font-bold text-white">{title}</h1>
                    <p className="text-sm text-gray-400 mt-2">
                        Effective Date: <span className="text-gray-300">{EFFECTIVE_DATE}</span>
                    </p>
                    <p className="text-xs text-gray-500 mt-2">
                        {PRODUCT_NAME} is a product of <strong>{LEGAL_ENTITY}</strong>.
                    </p>
                </header>

                {children}

                <footer className="mt-12 pt-6 border-t border-white/10">
                    <LandingLegalFooter />
                </footer>
            </div>
        </main>
    );
}
